export const scrollTo = {
  methods: {
    scrollTo(refName) {
      const el = this.$refs[refName];
      // const top = el.offsetTop;
      // const side = el.offsetWidth;
      // window.scrollTo(0, top);
      window.scrollTo(el);
    },
  },
};
